var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"loginPage","login-screen":""}},[_c('login',{attrs:{"has-restore-pass":true,"has-remember-me":true,"has-need-help":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }